import React, { Component } from 'react';
import { Modal,
    Alert,
    Popover,
    OverlayTrigger,
    FormGroup,
    ControlLabel,
    FormControl,
} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import Validation from 'react-validation';

// To handle requests
import AccountsAPI from '../utils/AccountsAPI';
import {
    passwordValidator,
    passwordConfirmationValidator,
    getPasswordValidationState
} from '../utils/passwordValidation';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class NewAccountButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            modalErrorAlert: '',
            username: '',
            email: '',
            quota: '',
            password: '',
            confirmationPassword: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitUser = this.submitUser.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            modalErrorAlert: '',
            username: '',
            email: '',
            quota: '',
            password: '',
            confirmationPassword: '',
        });
    }

    // Handle text input change to update state
    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    // Fired when form is submitted
    submitUser(e) {
        e.preventDefault();
        this.setState({ modalErrorAlert: '' });
        const { username, email, password, quota } = this.state;
        const host = window.location.hostname;
        return AccountsAPI.createAccount(username, email, password, quota, host)
        .then(res => {
            // Account has been created successfully
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
            this.closeModal();
            if (res.credentials) {
                this.setState({
                    showKeyModal: true,
                    keyInfos: {
                        UserName: res.account.name,
                        AccessKeyId: res.credentials.id,
                        SecretAccessKey: res.credentials.value,
                    },
                });
            }
        })
        .catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else if (message.status === 409) {
                this.setState({
                    modalErrorAlert: `Account name "${username}" or
                        Email "${email}" already in use.`,
                });
            } else if (message.status === 400) {
                this.setState({
                    modalErrorAlert: `Unable to create account.
                        Please verify that the account name is valid.`,
                });
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                        server returned an Internal Error.`,
                });
            }
        });
    }

    usernameValidator(specUsername) {
        const username = specUsername || this.state.username;

        // Username is too long
        if (username.length > 64) {
            return false;
        }

        // String validation
        const validationRegEx = /^[a-zA-Z0-9=,.@\-_+]*$/;
        return username.match(validationRegEx);
    }

    emailValidator(specEmail) {
        const email = specEmail || this.state.email;

        // Disabling eslint because of the regexp size.
        // This regexp makes sure the email is compliant with RFC 5322
        // eslint-disable-next-line
        const validationRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return email.match(validationRegEx);
    }

    quotaValidator(specQuota) {
        const quota = specQuota || this.state.quota;
        // Quota is not required
        if (!quota.length) {
            return true;
        }
        const floatValue = parseFloat(quota);
        return (!Number.isNaN(floatValue) && floatValue >= 0 &&
        floatValue.toString() === quota.toString());
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const accountHelpPopover = (
            <Popover id="popover-help-username" title="Naming restrictions">
                {'Account names can contain upper and lowercase alphanumeric ' }
                {'characters with no spaces. Account names may also include '}
                {'any of the following characters: =,.@-_+. It must have a '}
                {'minimum length of 1 and a maximum length of 64.'}
            </Popover>
        );

        const accountNameHelpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={accountHelpPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );

        const quotaHelpPopover = (
            <Popover id="popover-help-username" title="Account quota">
                {'The account space usage can be restricted using a quota. ' }
                {'The quota must be a number of gibibytes (GiB). A quota of 200 '}
                {'will limit the account disk usage to 200 GiB. '}
                {'A quota of 0 (or leaving the field empty) does not set any '}
                {'limit on the account.'}
            </Popover>
        );

        const quotaHelpIcon = (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={quotaHelpPopover}>
                    <i className="fa fa-question-circle-o"></i>
            </OverlayTrigger>
        );

        return (
            <div>
                <button
                  className="btn btn-primary new-account-btn"
                  style={brandingStyles.buttons.primary}
                  onClick={this.openModal}
                >
                    <i className="fa fa-plus fa-lg"></i>
                    <span>&nbsp;</span>
                    Create account
                </button>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-user-circle-o"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Create account
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <Validation.components.Form>

                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={
                                    this.state.username.length > 0 &&
                                    (this.usernameValidator() ?
                                    'success' : 'error') || null}>
                                <ControlLabel>
                                  <i
                                    className="fa fa-user"
                                    style={brandingStyles.mainColor}
                                  />
                                  &nbsp;Account name {accountNameHelpIcon}
                                </ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="text"
                                    value={this.state.username}
                                    onChange={this.handleChange}
                                    placeholder="Account name"
                                    name="username"
                                    validations={['required',
                                        'validUsername']}/>
                                <FormControl.Feedback />
                              </FormGroup>
                            </div>

                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={
                                  this.state.email.length > 0 &&
                                  (this.emailValidator() ? 'success' : 'error')
                                  || null
                                }>
                                <ControlLabel>
                                  <i
                                    className="fa fa-at"
                                    style={brandingStyles.mainColor}
                                  />
                                  &nbsp;Email address
                                </ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    placeholder="Email address"
                                    name="email"
                                    validations={['required',
                                        'validEmail']}/>
                                <FormControl.Feedback />
                              </FormGroup>
                            </div>

                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={
                                  this.state.quota.length > 0 &&
                                  (this.quotaValidator() ? 'success' : 'error')
                                  || null
                                }>
                                <ControlLabel>
                                  <i
                                    className="fa fa-tasks"
                                    style={brandingStyles.mainColor}
                                  />
                                  &nbsp;Account Quota {quotaHelpIcon}
                                </ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="text"
                                    value={this.state.quota}
                                    onChange={this.handleChange}
                                    placeholder="Account quota (GiB)"
                                    name="quota"
                                    validations={['validQuota']}/>
                                <FormControl.Feedback />
                              </FormGroup>
                            </div>


                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={
                                  // Password is optional for account creation, so we allow empty passwords
                                  getPasswordValidationState(this.state.password, passwordValidator)
                                }>
                                <ControlLabel>
                                  <i
                                    className="fa fa-lock"
                                    style={brandingStyles.mainColor}
                                  />
                                  &nbsp;Password
                                </ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="password"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    placeholder="Password"
                                    name="password"
                                    validations={['validPassword']}/>
                                <FormControl.Feedback />
                              </FormGroup>
                            </div>

                            <div className="form-group">
                              <FormGroup
                                controlId="formValidationError2"
                                validationState={
                                  this.state.confirmationPassword.length === 0 ? null :
                                      (passwordConfirmationValidator(
                                        this.state.password, this.state.confirmationPassword) ?
                                  'success' : 'error')
                              }>
                                <ControlLabel>
                                  <i
                                    className="fa fa-lock"
                                    style={brandingStyles.mainColor}
                                  />
                                  &nbsp;Password confirmation
                                </ControlLabel>
                                <Validation.components.Input
                                    className="form-control"
                                    style={brandingStyles.backgrounds.input}
                                    type="password"
                                    value={this.state.confirmationPassword}
                                    onChange={this.handleChange}
                                    placeholder="Confirm Password"
                                    name="confirmationPassword"
                                    validations={['validPassword',
                                        'validPasswordConfirmation']}/>
                                <FormControl.Feedback />
                              </FormGroup>
                            </div>


                            {errorAlert}
                            <Validation.components.Button
                              onClick={this.submitUser}
                              style={brandingStyles.buttons.primary}
                              className="btn btn-primary pull-right">
                              Submit
                            </Validation.components.Button>

                        </Validation.components.Form>
                        <div style={{
                            clear: 'both',
                        }}></div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}

NewAccountButtonComponent.propTypes = {
    callback: PropTypes.func,
};

export default NewAccountButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/NewAccountButton.js
 **/